import React from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';

const menuData = [
    {
        title: 'Home',
        path: '/',
    },

    {
        title: 'About',
        path: '/about',
    },

    {
        title: 'Services',
        path: '/services',
    },

    {
        title: 'Contact',
        path: '/#contact',
    },
];

export default menuData;
